import { render, staticRenderFns } from "./AddTrainingSchedule.vue?vue&type=template&id=c80be77a&scoped=true&"
import script from "./AddTrainingSchedule.vue?vue&type=script&lang=js&"
export * from "./AddTrainingSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80be77a",
  null
  
)

export default component.exports